<template>

  <MassiveShareCandidate
    :initShare="initShare"
    @hideModal="hideModal()" 
    @saved="created()" />

</template>

<script>
import MassiveShareCandidate from '@/components/MassiveShareCandidate/MassiveShareCandidate'

export default {
  name: 'JobActionMassShare',
  components: {
    MassiveShareCandidate
  },
  data () {
    return {
    }
  },
  computed: {
    job () {
      return this.$store.getters.getJob
    },
    candidates () {
      return this.$store.getters.getCandidateSelected
    },
    initShare () {
      return {
        candidates: this.candidates,
        job_id: this.job._id,
        permissions: {
          resume: true,
          profile: true,
          contacts: true,
          evaluations: true
        }
      }
    }
  },
  created () {
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    created () {
      this.hideModal()
      this.$store.dispatch('resetCandidateSelected')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobMassiveAction/JobMassiveActionShare.vue